import React from 'react';
import Header from '../Header/Header';

const NoMatch = () => {
    return (
        <div className="container">

        <Header></Header>

        <h2>the routher is not fount</h2>
            
        </div>
    );
};

export default NoMatch;